<div class="modal-header">
    <h5 class="modal-title">Status List</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body p-0">
    <dirty-tracking [forms]="[listForm]"></dirty-tracking>
    <form class="" novalidate #listForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
        <table class="table orderTable mb-0">
            <thead>
                <tr>
                    <th>Status Code</th>
                    <th>Display Name</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <!-- LINE ITEM -->
                <tr *ngFor="let item of theList; let idx = index;">
                    <td>
                        <input type="text" class="form-control" required placeholder="Status Code" [(ngModel)]="item.statusCode" [name]="'statusCode'+idx" />
                    </td>
                    <td>
                        <input type="text" class="form-control" required placeholder="Display Name" [(ngModel)]="item.displayName" [name]="'displayName'+idx" />
                    </td>
                    <td>
                        <a href="javascript:void(0)" (click)="remove(idx)"><i class="text-danger far fa-trash"></i></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>
</div>
<div class="modal-footer align-items-center justify-content-between">
    <a href="javascript:void(0)" (click)="add()"><i class="far fa-plus"></i> add code</a>
    <div>
        <button type="button" class="btn btn-outline-black btn-round btn-lg me-2" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>
            Save</button>
    </div>
</div>